export const ASSET_INVENTORY_CONSTANTS = {
    ASSET_INVENTORY_PATHNAME : 'assetinventory',
    USERS: 'users',
    AUDIT_DATES: 'auditdates',
    SUCCESS: 'success',
    FAILED: 'failed',
    MERGER_AND_ACQUISITION: 'mergerandacquisitionscan',
    QUESTIONS: 'questions',
    ASSETINVENTORYREADINESS: 'assetInventoryReadiness'
}